import { apiService } from "./apiService";

export const userApi = {
  // Get user profile
  getProfile: async () => {
    try {
      return await apiService.get("/user/profile");
    } catch (error) {
      throw error;
    }
  },

  // Update user profile
  updateProfile: async (profileData: any) => {
    try {
      return await apiService.put("/user/profile", profileData);
    } catch (error) {
      throw error;
    }
  },

  // Get user dashboard data
  getDashboard: async () => {
    try {
      return await apiService.get("/user/dashboard");
    } catch (error) {
      throw error;
    }
  },

  // Get user order history with pagination + status filter
  getOrderHistory: async (params: {
    page?: number;
    limit?: number;
    status?: string;
  }) => {
    try {
      return await apiService.get("/user/orders", { params });
    } catch (error) {
      throw error;
    }
  },

  // Get user purchase statistics
  getPurchaseStats: async () => {
    try {
      return await apiService.get("/user/purchase-stats");
    } catch (error) {
      throw error;
    }
  },
};
